module.exports = __webpack_public_path__ + "img/skinxs-logo-simple.65c51274.svg";